import { IBritaxProductRegistrationView } from '../britax-product-registration';
import { InputID, productRegistrationState } from '../model/model';

export const handleValidation = (
    name: string,
    value: string,
    props: IBritaxProductRegistrationView,
    formData: productRegistrationState
): string => {
    const {
        firstNameErrorMessage,
        lastNameErrorMessage,
        emailErrorMessage,
        contactNumberErrorMessage,
        contactNumberMaxLengthErrorMessage,
        productTypeErrorMessage,
        productNameErrorMessage,
        storeNameErrorMessage,
        dateOfPurchaseErrorMessage,
        dateOfManufactureErrorMessage,
        itemNumberErrorMessage,
        serialNumberErrorMessage,
        reorderCodeErrorMessage
    } = props?.resources;
    const { isNZBasedConfig } = props?.config;
    switch (name) {
        case InputID.firstName:
            if (!value) {
                return firstNameErrorMessage;
            }
            break;
        case InputID.lastName:
            if (!value) {
                return lastNameErrorMessage;
            }
            break;
        case InputID.email:
            if (!value) {
                return emailErrorMessage;
            }
            break;
        case InputID.contactNumber:
            if (!isNZBasedConfig) {
                if (!value) {
                    return contactNumberErrorMessage;
                } else if (!/^[0-9]{10}$/.test(value)) {
                    return contactNumberMaxLengthErrorMessage;
                }
            }
            break;
        case InputID.productType:
            if (!value) {
                return productTypeErrorMessage;
            }
            break;
        case InputID.productName:
            if (!value) {
                return productNameErrorMessage;
            }
            break;
        case InputID.storeName:
            if (!value) {
                return storeNameErrorMessage;
            }
            break;
        case InputID.dateOfManufacture:
            if (!value) {
                return dateOfManufactureErrorMessage;
            }
            break;

        case InputID.dateOfPurchase:
            if (!value) {
                return dateOfPurchaseErrorMessage;
            }
            break;
        case InputID.itemNumber:
            if (!value && formData[InputID.productType] === 'stroller') {
                return itemNumberErrorMessage;
            }
            break;
        case InputID.serialNumber:
            if (!value && formData[InputID.productType] === 'carSeat') {
                return serialNumberErrorMessage;
            }
            break;
        case InputID.reorderCode:
            if (!value && formData[InputID.productType] === 'carSeat') {
                return reorderCodeErrorMessage;
            }
            break;
        default:
            break;
    }
    return '';
};
export const validateField = (
    name: string,
    value: string,
    props: IBritaxProductRegistrationView,
    formData: productRegistrationState
): any => {
    // Destructure error messages from props
    const {
        firstNameErrorMessage,
        lastNameErrorMessage,
        emailErrorMessage,
        contactNumberErrorMessage,
        contactNumberMaxLengthErrorMessage,
        productTypeErrorMessage,
        productNameErrorMessage,
        storeNameErrorMessage,
        dateOfPurchaseErrorMessage,
        dateOfManufactureErrorMessage,
        itemNumberErrorMessage,
        serialNumberErrorMessage,
        reorderCodeErrorMessage
    } = props?.resources || {
        firstNameErrorMessage: '',
        lastNameErrorMessage: '',
        emailErrorMessage: '',
        contactNumberErrorMessage: '',
        contactNumberMaxLengthErrorMessage: '',
        productTypeErrorMessage: '',
        productNameErrorMessage: '',
        storeNameErrorMessage: '',
        dateOfPurchaseErrorMessage: '',
        dateOfManufactureErrorMessage: '',
        itemNumberErrorMessage: '',
        serialNumberErrorMessage: '',
        reorderCodeErrorMessage: ''
    };
    const { isNZBasedConfig } = props?.config;
    // Copy existing errors or initialize new errors object
    const newErrors = { ...formData };

    // Switch statement to handle validation logic based on field name
    switch (name) {
        case InputID.firstName:
            newErrors[InputID.firstName] = !value ? firstNameErrorMessage : '';
            break;
        case InputID.lastName:
            newErrors[InputID.lastName] = !value ? lastNameErrorMessage : '';
            break;
        case InputID.email:
            newErrors[InputID.email] = !value ? emailErrorMessage : '';
            break;
        case InputID.contactNumber:
            if (!isNZBasedConfig) {
                if (!value) {
                    newErrors[InputID.contactNumber] = contactNumberErrorMessage;
                } else if (!/^[0-9]{10}$/.test(value)) {
                    newErrors[InputID.contactNumber] = contactNumberMaxLengthErrorMessage;
                } else {
                    newErrors[InputID.contactNumber] = ''; // Clear error message if valid
                }
            }
            break;
        case InputID.productType:
            newErrors[InputID.productType] = !value ? productTypeErrorMessage : '';
            break;
        case InputID.productName:
            newErrors[InputID.productName] = !value ? productNameErrorMessage : '';
            break;
        case InputID.storeName:
            newErrors[InputID.storeName] = !value ? storeNameErrorMessage : '';
            break;
        case InputID.dateOfManufacture:
            newErrors[InputID.dateOfManufacture] = !value ? dateOfManufactureErrorMessage : '';
            break;
        case InputID.dateOfPurchase:
            newErrors[InputID.dateOfPurchase] = !value ? dateOfPurchaseErrorMessage : '';
            break;
        case InputID.itemNumber:
            newErrors[InputID.itemNumber] = !value && formData[InputID.productType] === 'stroller' ? itemNumberErrorMessage : '';
            break;
        case InputID.serialNumber:
            newErrors[InputID.serialNumber] = !value && formData[InputID.productType] === 'carSeat' ? serialNumberErrorMessage : '';
            break;
        case InputID.reorderCode:
            newErrors[InputID.reorderCode] = !value && formData[InputID.productType] === 'carSeat' ? reorderCodeErrorMessage : '';
            break;
        default:
            break;
    }

    return newErrors;
};
